var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"czCover",class:'czCover--' + _vm.size},[(_vm.image)?_c('img',{staticClass:"czCover__img",attrs:{"src":_vm.image,"alt":""}}):_c('span',{staticClass:"czCover__name"},[_vm._v(_vm._s(_vm.name))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }